export default "__VITE_ASSET__VEOtBSka__"